.card {
  width: 100%;
  box-sizing: border-box;
  padding: var(--gac-space-sm) var(--gac-space-md);
  border-radius: var(--gac-radius-md);
  background: var(--gac-surface-raised);
  border: 1px solid var(--gac-line-border);
}

.row {
  display: flex;
  justify-content: space-between;
  gap: var(--gac-space-xs);
}

/* The total is the line the eye goes to, so it is the only one with a rule above it. */
.total {
  border-top: 1px solid var(--gac-line-divider);
  margin-top: var(--gac-space-xs);
  padding-top: var(--gac-space-xs);
}

/* A second currency never joins the sum — it sits under the total, visibly outside it. */
.footnote {
  margin-top: var(--gac-space-xxs);
}

/* Prose under the total (the network fees the wallet pays itself): a sentence, not a line of the sum. */
.note {
  margin-top: var(--gac-space-xxs);
}

.meta {
  margin-top: var(--gac-space-sm);
  padding-top: var(--gac-space-sm);
  border-top: 1px solid var(--gac-line-divider);
}

.link {
  color: var(--gac-accent);
  text-decoration: none;
  word-break: break-all;
}

.link:hover {
  text-decoration: underline;
}
